import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PatchMachineryRequirement from '.';

interface IPostMachineryRequirementProps {
  onSuccess?: (data: any) => void;
  guid?: string;
}

const usePatchMachineryRequirement = ({
  onSuccess,
  guid,
}: IPostMachineryRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IMachineryRequirementPayload) => {
      return PatchMachineryRequirement(payload, guid);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
      // refetchAllComments();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePatchMachineryRequirement};
